import React from 'react';

function createOptions(options, label) {
  return (
    <optgroup label={label}>
      {
        options.map(
          o => <option key={o.get('id')} value={o.get('id')}>{o.get('name')}</option>
        )
      }
    </optgroup>
  )
}

export function createPositionOptions(positionList) {
  return createOptions(positionList.filter(p => p.get('type') == 0), "職業")
}

export function createWorkCategoryOptions(positionList) {
  return createOptions(positionList.filter(p => p.get('type') == 1), "工序")
}


// WEBPACK FOOTER //
// ./src/components/Schedule/createPositionptions.js